import api from './api';

export async function getAdminSettings() {
  const { data } = await api.get('/admin/settings');
  return data;
}

export async function getAdminSettingsRaw() {
  const { data } = await api.get('/admin/settings', { params: { raw: 1 } });
  return data;
}

export async function updateAdminSettings(payload) {
  const { data } = await api.patch('/admin/settings', payload);
  return data;
}

export async function getShopSettings() {
  const { data } = await api.get('/shop-settings');
  return data;
}
